import * as apiUtils from "@/utils/apiUtils"

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {},
  // -----------------------------------------------------------------
  getters: {},
  // -----------------------------------------------------------------
  mutations: {},
  // -----------------------------------------------------------------
  actions: {
    // Products
    getProduct: (context, tid) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/products/" + tid
      return apiUtils.get(path)
    },
    getProducts: (context, query) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/products"
      return apiUtils.get(path, query)
    },
    createProduct: (context, { name, description, price, taxIds, incomeAccountId, expenseAccountId }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/products"
      return apiUtils.post(path, {
        name,
        description,
        price,
        taxIds,
        incomeAccountId,
        expenseAccountId
      })
    },
    updateProduct: (context, { id, name, description, price, taxIds, incomeAccountId, expenseAccountId }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/products/" + id
      return apiUtils.patch(path, {
        name,
        description,
        price,
        taxIds,
        incomeAccountId,
        expenseAccountId
      })
    },
    deleteProduct: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/products/" + id
      return apiUtils.delete(path)
    }
  }
}
